import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getClubByShortSlug } from '../utils/clubSlugUtils';

function ClubRedirect() {
  const { shortSlug, clubSlug, citySlug, number } = useParams();
  
  // List of known static routes that should not be processed as club slugs
  const staticRoutes = [
    'blogs', 'aboutus', 'addclub', 'releases', 'help', 'runclubs', 
    'runclub', 'club', 'test-club-urls'
  ];
  
  // Determine the actual slug to look up based on URL pattern
  let actualSlug = null;
  
  if (number) {
    // Three-part URL: /clubname/city/number
    actualSlug = `${clubSlug}/${citySlug}/${number}`;
  } else if (citySlug) {
    // Two-part URL: /clubname/city
    actualSlug = `${clubSlug}/${citySlug}`;
  } else if (shortSlug) {
    // Single-part URL: /clubname
    actualSlug = shortSlug;
  }
  
  // Check if this is a static route (only for single-part URLs)
  const isStaticRoute = shortSlug && staticRoutes.includes(shortSlug);
  
  // Get club data using the constructed slug (only if not a static route)
  const clubData = !isStaticRoute && actualSlug ? getClubByShortSlug(actualSlug) : null;
  
  // React Hook must be called unconditionally
  useEffect(() => {
    // Track the short URL usage for analytics
    if (clubData && window.gtag) {
      window.gtag('event', 'short_url_used', {
        club_name: clubData.title,
        club_city: clubData.city,
        short_slug: actualSlug,
        original_route: clubData.originalRoute
      });
    }
  }, [clubData, actualSlug]);
  
  // If this matches a static route, redirect to homepage
  if (isStaticRoute) {
    return <Navigate to="/" replace />;
  }
  
  // If club found, redirect to the full route
  if (clubData) {
    return <Navigate to={clubData.originalRoute} replace />;
  }
  
  // If no club found, redirect to homepage
  return <Navigate to="/" replace />;
}

export default ClubRedirect; 